import {Component, Inject, OnInit,} from '@angular/core';

import {ActivatedRoute, Router} from '@angular/router';

import {AlertService, AuthenticationService, ControlItemsService, UserService,} from '../../_services/index';

import {User} from '../../_models/index';

import {MatDialog, MatDialogConfig, MatDialogRef} from '@angular/material/dialog';

import {LoginHelper, Recurring, Role} from '../../helpers';
import {DOCUMENT} from "@angular/common";
import * as moment from 'moment';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {SelectControlItemComponent} from "../selectControlItem/select-control-item.component";
import {forkJoin} from "rxjs";
import {AssessmentService} from "../../_services/assessment.service";
import {IndexConfigService} from "../../_services/index.config.service";
import {AssessmentInviteComponent} from "../assessmentInvite/assessment-invite.component";
import {AssessmentUserAnswersComponent} from "../assessmentUserAnswers/assessmentUserAnswers.component";
import {saveAs as importedSaveAs} from "file-saver";

const defaultDialogConfig = new MatDialogConfig();

@Component({
    standalone: false,
  selector: "assessment-edit-component",
  templateUrl: 'assessment-edit.component.html',
  styleUrls: ['./assessment-edit.component.scss'],
})

export class AssessmentEditComponent implements OnInit {
  public selectDialogRef: MatDialogRef<SelectControlItemComponent>;
  api: string = window.location.origin;
  tenantName: string = LoginHelper.getTenantName();
  quizForm: FormGroup;
  token: string = LoginHelper.getFileToken();
  users: User[] = [];
  inviteText = '';
  recurringList = [];
  recurring = {};
  window = window;
  quiz = {
    id: 0,
    name: '',
    quiz: '',
    ownerIds: '',
    notifiedIds: '',
    quizData: {
      name: '',
      steps: [
        {name: '', items: []}
      ]
    },
    versionName: '1',
    completionName: '',
    isCompletionNameLocked: false,
    assessmentUsers: []
  };
  allUsers: User[];
  assignedUsers: any[] = [];
  assessmentId: number;
  cols: any[] = [
    {'field': 'category', 'header': 'Category'},
    {'field': 'complianceAreaControlId', 'header': 'Control ID'},
    {'field': 'description', 'header': 'Description'}
  ];
  fromDate = '';
  toDate = '';
  activeTab = 0;

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public alertService: AlertService,
    public authenticationService: AuthenticationService,
    public controlItemsService: ControlItemsService,
    public userService: UserService,
    public dialog: MatDialog,
    @Inject(DOCUMENT) public document: any,
    public _formBuilder: FormBuilder,
    public config: IndexConfigService,
    public assessmentService: AssessmentService) {
  }

  ngOnInit() {
    for (let i = 0; i <= Recurring.Yearly; i++) {
      this.recurringList.push({label: Recurring[i].toString(), value: i});
      this.recurring[i] = Recurring[i].toString();
    }
    this.route.params.subscribe(p => {
      this.assessmentId = p['id'];
      if (this.assessmentId == 0) {
        this.quiz = {
          id: 0,
          name: '',
          ownerIds: '',
          notifiedIds: '',
          quiz: '',
          versionName: '1',
          completionName: '',
          isCompletionNameLocked: false,
          quizData: {name: '', steps: [{name: "", items: []}]},
          assessmentUsers: []
        };
      }

      this.loadUsers();

    });
    this.quizForm = this._formBuilder.group({
      name: ['', Validators.required],
      versionName: ['1'],
      completionName: ['', Validators.required],
      isCompletionNameLocked: [false],
      ownerList: [[]],
      notifiedList: [[]],
    });
  }

  loadUsers() {
    forkJoin(
      this.userService.getAllShort(),
      this.controlItemsService.getAll(),
      this.assessmentService.getAssessment(this.assessmentId),
      this.assessmentService.getAssessmentResults(),
    ).subscribe(r => {
      const users = r[0];
      const controlItems = r[1];
      this.quiz = r[2] || this.quiz;

      this.inviteText = 'Please login to <a href="' + location.origin + '">Rizkly</a> to complete the ' + this.quiz.quizData.name + ' survey.  Note: you will need your Rizkly login ID and password.  Contact your survey administrator for assistance if you do not already have login credentials.';
      const answers = r[3];
      const assigned = (this.quiz.assessmentUsers || []).map(u => ({
        assignmentUser: u,
        usr: users.find(a => a.userId == u.userId)
      })).filter(u => u.usr);

      answers.filter(a => a.assessmentId == this.assessmentId && a.date && a.isFinished && a.answers).forEach(a => {
        if (!assigned.find(s => s.usr && s.usr.userId == a.userId)) {
          assigned.push({assignmentUser: null, usr: users.find(u => a.userId == u.userId)});
        }
      });

      this.allUsers = users.filter(r => (r.role & (Role.PrimaryManager | Role.PrimaryAdvisorLead | Role.PlatformSupport | Role.AdvisorLead | Role.Manager)) > 0);
      this.users = assigned.map(u => {
        const userAnswers = answers.filter(a => a.assessmentId == this.assessmentId && u.usr && a.userId == u.usr.userId && a.isFinished && a.answers).sort((a, b) => a.date - b.date);
        return {
          ...u.usr, ...u.assignmentUser,
          answers: userAnswers,
          nextDate: u.assignmentUser ? u.assignmentUser.frequency == Recurring.None ? null :
            u.assignmentUser.frequency == Recurring.Daily ? moment(userAnswers.length > 0 ? userAnswers[0].date : new Date()).add(1, 'day').toDate() :
              u.assignmentUser.frequency == Recurring.Weekly ? moment(userAnswers.length > 0 ? userAnswers[0].date : new Date()).add(1, 'week').toDate() :
                u.assignmentUser.frequency == Recurring.Monthly ? moment(userAnswers.length > 0 ? userAnswers[0].date : new Date()).add(1, 'month').toDate() :
                  u.assignmentUser.frequency == Recurring.Quarterly ? moment(userAnswers.length > 0 ? userAnswers[0].date : new Date()).add(1, 'quarter').toDate() :
                    moment(userAnswers.length > 0 ? userAnswers[0].date : new Date()).add(1, 'year').toDate() : null
        };
      });
      this.quiz.quizData = this.quiz.quizData || {name: '', steps: [{name: "", items: []}]};
      this.quiz.quizData.steps = this.quiz.quizData.steps || [];
      if (this.quiz.quizData.steps.length == 0) {
        this.quiz.quizData.steps.push({name: "", items: []});
      }

      let ownerList = ((this.quiz.ownerIds || '').split(',') || []).map(t => this.allUsers.find(u => u.userId == parseInt(t))).filter(u => u);
      let notifiedList = ((this.quiz.notifiedIds || '').split(',') || []).map(t => this.allUsers.find(u => u.userId == parseInt(t))).filter(u => u);

      this.quizForm.patchValue({
        name: this.quiz.quizData.name,
        versionName: this.quiz.versionName,
        completionName: this.quiz.completionName,
        isCompletionNameLocked: this.quiz.isCompletionNameLocked,
        ownerList: ownerList,
        notifiedList: notifiedList
      });

      this.quiz.quizData.steps.forEach(s => {
        s.items.forEach(i => {
          i.controlItems = controlItems.filter(t => (i.controlItemIds || []).find(d => d == t.controlItemId));
        })
      })
    });
  }

  send() {
    if (this.quizForm.valid) {
      this.quiz.quizData.steps.forEach(s => {
        s.items.forEach(i => {
          if (i.controlItems) {
            i.controlItemIds = i.controlItems.map(t => t.controlItemId);
          }
        })
      })
      this.quiz.ownerIds = (this.quizForm.value.ownerList || []).map(a => a.userId).join(',');
      this.quiz.notifiedIds = (this.quizForm.value.notifiedList || []).map(a => a.userId).join(',');
      this.quiz.quiz = JSON.stringify(this.quiz.quizData);
      this.assessmentService.assessmentExists(this.assessmentId, this.quiz.quizData.name).subscribe((result) => {
        if (result.exists) {
          this.alertService.success("Name already exists");
        } else {
          this.assessmentService.saveAssessment(this.quiz).subscribe((saved) => {
            this.assessmentService.updateList.next(true);
            this.alertService.success("Successfully saved");
            this.router.navigate(['/assessments/assessment', saved.id, 'edit']);
          });
        }
      });
    }
  }

  invite() {
    let config: MatDialogConfig = {
      width: "90%",
      height: "90%",
      data: {
        assessmentId: this.assessmentId
      }
    };

    const ref = this.dialog.open(AssessmentInviteComponent, config);

    ref.afterClosed().subscribe((data: any) => {
      this.loadUsers();
    });
  }

  sendInvite() {
    if (this.assignedUsers.length == 0) {
      this.alertService.success("Please, select users");
      return;
    }
    this.assessmentService.inviteToAssessment({
      ...this.quiz,
      assessmentUsers: this.assignedUsers.map(u => ({userId: u.userId, assessmentId: this.assessmentId}))
    }, this.inviteText).subscribe(() => {
      this.assignedUsers = [];
      this.alertService.success("Message successfully sent");
    });
  }

  addStep() {
    this.quiz.quizData.steps.push({name: '', items: []})
  }

  removeStep(i) {
    setTimeout(() => this.quiz.quizData.steps.splice(i, 1), 500);
  }

  moveUp(list, i) {
    const s = list[i];
    list[i] = list[i - 1];
    list[i - 1] = s;
  }

  moveDown(list, i) {
    const s = list[i];
    list[i] = list[i + 1];
    list[i + 1] = s;
  }

  addQuestion(list) {
    list.push({type: 'question', name: '', answers: [], multiple: false, controlItems: []});
  }

  addTextQuestion(list) {
    list.push({type: 'textQuestion', name: '', answers: [], multiple: false, controlItems: []});
  }

  addYesNoQuestion(list) {
    list.push({type: 'yesNoQuestion', name: '', answers: [{name: 'Yes', controlItems: []}, {name: 'No', controlItems: []}, {name: 'Partial', controlItems: []}], multiple: false, controlItems: []});
  }

  addAttachment(list) {
    list.push({type: 'attachment', name: '', answers: [], multiple: false, controlItems: []});
  }

  addAnswer(list) {
    list.push({name: '', controlItems: []});
  }

  removeItProfile() {
    this.assessmentService.updateList.next(true);
    this.assessmentService.deleteAssessment(this.assessmentId).subscribe(t => {
      this.router.navigate(['profiles']);
      this.assessmentService.updateList.next(true);
    });
  }

  addControlItem(list) {
    let config: MatDialogConfig = {
      width: "90%",
      height: "90%",
      data: {
        except: list || []
      }
    };

    this.selectDialogRef = this.dialog.open(SelectControlItemComponent, config);

    this.selectDialogRef.afterClosed().subscribe((data: any) => {
      if (data)
        list.push(data);
    });
  }

  removeControlItem(list, item) {
    const index = list.controlItems.findIndex(cItem => cItem.controlItemId === item.controlItemId);
    if (index !== -1) {
      list.controlItems.splice(index, 1);
    }
  }

  stepClick(ev) {
    console.log(ev)
  }

  getFullName(user) {
    if (!user) {
      return '';
    }

    if (user.firstName
      || user.lastName) {
      return user.firstName + ' ' + user.lastName;
    }

    return user.emailAddress;
  }

  open(item) {
    let config: MatDialogConfig = {
      panelClass: 'custom-overlay-pane-class',
      width: '98%',
      height: '90vh',
      data: {
        quiz: this.quiz,
        answers: [{...item, results: JSON.parse(item.answers)}],
        assessmentId: this.assessmentId,
      }
    };

    const dialogRef = this.dialog.open(AssessmentUserAnswersComponent, config);
  }

  updateFrequency(item, frequency) {
    this.quiz.assessmentUsers.find(u => u.userId == item.userId).frequency = frequency;
    this.send();
  }

  exportAnswers() {
    if (!this.assignedUsers || this.assignedUsers.length == 0) {
      this.alertService.error('Please, select users to export');
      return;
    }

    this.assessmentService.exportAnswers(this.assessmentId, null, this.assignedUsers.map(b => b.userId), this.fromDate, this.toDate).subscribe(blob => {
        importedSaveAs(new Blob([blob], {type: 'application/ms-excel'}), 'Rizkly Survey Answers.xlsx');
      },
      error => {
        const errorMessage = 'An error occurred while downloading results.';
        this.alertService.error(errorMessage);
      });

  }
}
